import { Config } from "../../../configurations/config";
export const Resource_APIs = {
	GetAllDepartments_API: `${Config.server_url}${Config.api_prefix}/Department/GetAllDepartments`,
	GetDepartmentEmployees_API: `${Config.server_url}${Config.api_prefix}/Department/GetDepartmentEmployees?departmentId=`,
	GetDepartmentItems_API: `${Config.server_url}${Config.api_prefix}/Department/GetDepartmentTicketItems?departmentId=`,
	PutTicket_API: `${Config.server_url}${Config.api_prefix}/Ticket/PutTicketDetails`,
	GetTicketDetail_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetTicketDetails?TicketId=`,
	EditTicketByCreator_API: `${Config.server_url}${Config.api_prefix}/Ticket/EditTicketByCreator`,
	EditTicketImage_API: `${Config.server_url}${Config.api_prefix}/Ticket/EditTicketImage`,
	GetAllResourceTickets_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetCreatedTickets?EmployeeId=`,
	DeleteTicket_API: `${Config.server_url}${Config.api_prefix}/Ticket/DeleteTicket?TicketId=`,
	GetTicketForwardToNames: `${Config.server_url}${Config.api_prefix}/Department/GetDepartmentEmployees?departmentId=`,
	ForwardTicketTo: `${Config.server_url}${Config.api_prefix}/Ticket/AssignTicket`,
};
